import MenuIcon from "@mui/icons-material/Menu";
import LogoutOutlined from "@mui/icons-material/LogoutOutlined";
import { useEffect, useRef, useState } from "react";
import appHeaderStyles from "./AppHeader.styles";
import {
  AppBar,
  Box,
  Grid,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { drawerWidth } from "../../utils/styles";
import { useLocation } from "react-router-dom";
import UserIcon from "../../assets/icons/User.svg";
import chieldIcon from "../../assets/icons/Chield.svg";
import logoutIcon from "../../assets/icons/Sign_in_circle.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  logOutAction,
  selectEmail,
  selectName,
  selectRole,
  selectUserId,
} from "../../redux/authSlice";
import urls from "../../global/constants/UrlConstants";
import history from "../../utils/history";
import { clearNotificationToken } from "../../utils/PushNotification/pushNotificationService";
import PunchInOut from "./components/PunchInOut/PunchInOut";
import OngoingCallChip from "./OngoingCallChip";
import { useAppSelector } from "../../utils/hooks";
import { RootState, store } from "../../utils/store";
import IdealTime from "../IdealTime/IdealTime";
import { isTruthy, openErrorNotification } from "../../helpers/methods";
import notifiers from "../../global/constants/NotificationConstants";
import customErrorHandler from "../../utils/customErrorHandler";
import { getPerosnalDetails } from "../../screens/Team/components/stepper/StepperService";
import { getNotification, updatePushNotification } from "../../utils/PushNotification/pushNotificationService";
import { notificationBelongsToUser } from "../../notifications/leadRealtime";
import { addNotification, clearNotifications } from "../../redux/notificationDataSlice";
import toast from "react-hot-toast";
import NotificationPanel from "./components/NotificationPanel";
import OrgSwitcher from "../OrgSwitcher/OrgSwitcher";

interface AppHeaderProps {
  sidebarWidth?: number;
  onToggleSidebar?: () => void;
}

const AppHeader = ({
  sidebarWidth = drawerWidth,
  onToggleSidebar,
}: AppHeaderProps) => {
  const classes = appHeaderStyles;
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);

  const dispatch = useDispatch();
  // const dispatch = useAppDispatch();
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const location = useLocation();
  const pathname = location.pathname;
  const [currPage, setCurrPage] = useState<string>("");
  const [userDropdown, setUserDropdown] = useState<boolean>(false);
  const [userData, setUserData] = useState<any>();
  const userRole = store.getState().auth.role;
  const userNameFromRedux = useAppSelector(selectName);
  const userEmailFromRedux = useAppSelector(selectEmail);
  const userIdFromRedux = useAppSelector(selectUserId);
  const roleFromRedux = useAppSelector(selectRole);
  const pageName = pathname.substring(pathname.lastIndexOf("/") + 1);
  // const [notifications, setNotifications] = useState([
  //   {
    
  //     message: "You have a new message from",
  //     time: "10:00 AM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
     
  //     message: "Your task is due tomorrow.",
  //     time: "12:30 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
     
  //     message: "Someone commented on your post.",
  //     time: "3:15 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
     
  //     message: "Your profile has been updated.",
  //     time: "5:45 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
  //     message: "You have a new follower.",
  //     time: "7:00 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
  //     message: "You have a new follower.",
  //     time: "7:00 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
  //     message: "You have a new follower.",
  //     time: "7:00 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
  //     message: "You have a new follower.",
  //     time: "7:00 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
  //     message: "You have a new follower.",
  //     time: "7:00 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
  //     message: "You have a new follower.",
  //     time: "7:00 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
  //     message: "You have a new follower.",
  //     time: "7:00 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
  //     message: "You have a new follower.",
  //     time: "7:00 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  //   {
  //     message: "You have a new follower.",
  //     time: "7:00 PM",
  //     dataSource: "Housing.com",
  //     developerName: "ATS Infrastructure Limited",
  //     leadName: "John",
  //   },
  // ]);

  const [notifications, setNotifications] = useState<any[]>([]);
  // const notificationCount = notifications.length;
  const notificationCount = notifications.filter((n:any) => n.status === "unread").length;

  useEffect(() => {
    const path = location.pathname;
    const pageName = path.substring(path.lastIndexOf("/") + 1);
    setCurrPage(pageName);
  }, [location]);

  useEffect(() => {
    init();
  }, []);
  // useEffect(() => {
  //   // Listen to incoming notifications
  //   onMessage(messaging, async (payload) => {
  //     console.log("New Notification Received:", payload);
  
  //     // Automatically refresh notifications list
  //     let notificationData = await getNotification();
  //     setNotifications(notificationData.data);
  //   });
  // }, []);
  // useEffect(() => {
  //   onMessage(messaging, async (payload) => {
  //     // console.log("Message received. ", payload);
  //     // let notificationData = await getNotification();
  //     // console.log(notificationData,"notificationDatanotificationData")
  //     console.log(store.getState().notification.notifications,"notificationDataaaaaaaaaaaaaaa")
      
  //   });
  // }, []);

  const notData = useSelector(
    (state: RootState) => state.notification.notifications
  );

  useEffect(() => {
    const parsedNotification =
      typeof notData === "string" ? JSON.parse(notData) : notData;
    const me = String(store.getState().auth?.userId || "").trim();
    const list: any[] = Array.isArray(parsedNotification)
      ? parsedNotification
      : [];
    // Defense: never show another user's targeted notification in this bell
    const mine: any[] = me
      ? list.filter((n: any) => notificationBelongsToUser(n, me))
      : [];
    setNotifications(mine);
  }, [notData]); 
  
  // const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const init = async () => {
    try {
      let response = await getPerosnalDetails(store.getState().auth?.userId);
      customErrorHandler(response);
      setUserData(response.data);
    let notificationData = await getNotification();
    dispatch(addNotification(notificationData?.data?.flat() ?? []));

    // console.log(store.getState().notification.notifications,"notificationDataaaaaaaaaaaaaaa")
    // const notificationData = store.getState().notification.notifications;
    // const parsedNotification = typeof notificationData === "string" ? JSON.parse(notificationData) : notificationData;
    
    // setNotifications(notificationData.data);
    
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error?.message) ? error?.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const handleUserDropDown = () => {
    setUserDropdown(!userDropdown);
  };

  const handleProfile = () => {
    setUserDropdown(false);
    history.push(urls.accountProfilePath);
  };

  const handleSecurity = () => {
    setUserDropdown(false);
    history.push(urls.accountSecurityPath);
  };

  const logout = async () => {
    try {
      const uid = String(userIdFromRedux || "").trim();
      if (uid) {
        await clearNotificationToken({ userId: uid, source: "web" });
      }
    } catch {
      // ignore — still log out
    }
    try {
      Object.keys(localStorage)
        .filter((k) => k.startsWith("notificationTokenSaved_"))
        .forEach((k) => localStorage.removeItem(k));
    } catch {
      // ignore
    }
    dispatch(logOutAction());
    dispatch(clearNotifications());
    toast.dismiss();
    history.push(urls.loginViewPath);
  };

  const [notifOpen, setNotifOpen] = useState(false);
  const notifBtnRef = useRef<HTMLButtonElement | null>(null);
  const userMenuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!userDropdown) return;
    const onDocClick = (e: MouseEvent) => {
      if (
        userMenuRef.current &&
        !userMenuRef.current.contains(e.target as Node)
      ) {
        setUserDropdown(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [userDropdown]);

  const userInitial =
    String(userNameFromRedux || "U")
      .trim()
      .charAt(0)
      .toUpperCase() || "U";
  const displayEmail =
    userEmailFromRedux ||
    userData?.email ||
    userData?.work_email ||
    "";

  const handleNotificationClick = () => {
    setNotifOpen((v) => !v);
    setUserDropdown(false);
  };

  const handleNotificationUnreadClick = async (notification: any) => {
    if (notification.status === "unread") {
      try {
        const payload = {
          notificationId: notification._id,
          userId: notification.userId,
        };
        const response = await updatePushNotification(payload);
        if (response.success === 1) {
          init();
        }
        init();
      } catch (error) {
        console.error("Error updating notification status:", error);
      }
    }
  };

  const handleMarkAllRead = async () => {
    const unread = (notifications || []).filter(
      (n: any) => n.status === "unread"
    );
    try {
      await Promise.all(
        unread.map((n: any) =>
          updatePushNotification({
            notificationId: n._id,
            userId: n.userId,
          })
        )
      );
      await init();
    } catch (error) {
      console.error("Error marking all as read:", error);
    }
  };

  const getAppHeader = () => {
    return (
      <Box
        sx={{
          ...classes.appHeader,
          width: `calc(100% - ${sidebarWidth}px)`,
          transition: "width 0.25s ease",
        }}
      >
        <Grid container>
          {userDropdown && (
            <Box
              onClick={() => setUserDropdown(false)}
              sx={{ height: "100vh", width: "100vw", position: "absolute" }}
            />
          )}
          <Grid item xs={6}>
            <Box sx={classes.leftHeader}>
              <IconButton
                aria-label="Toggle sidebar"
                onClick={() => onToggleSidebar?.()}
                sx={{ ml: 1, color: "#374151" }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={classes.rightHeader}>
              <OngoingCallChip />
              <OrgSwitcher />
              <PunchInOut />

              <div className="relative">
                <button
                  ref={notifBtnRef}
                  type="button"
                  onClick={handleNotificationClick}
                  className="relative flex h-10 w-10 items-center justify-center rounded-xl text-[#374151] transition hover:bg-[#F3F4F6]"
                  aria-label="Notifications"
                  aria-expanded={notifOpen}
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.75"
                  >
                    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
                    <path d="M13.73 21a2 2 0 01-3.46 0" />
                  </svg>
                  {notificationCount > 0 ? (
                    <span className="absolute -right-0.5 -top-0.5 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[#EF4444] px-1 text-[10px] font-bold text-white">
                      {notificationCount > 99 ? "99+" : notificationCount}
                    </span>
                  ) : null}
                </button>

                <NotificationPanel
                  open={notifOpen}
                  onClose={() => setNotifOpen(false)}
                  notifications={notifications || []}
                  unreadCount={notificationCount}
                  onMarkRead={handleNotificationUnreadClick}
                  onMarkAllRead={handleMarkAllRead}
                  ignoreRef={notifBtnRef}
                />
              </div>

              <Box display={"flex"} gap={"20px"}>
                <Box ref={userMenuRef} sx={{ position: "relative" }}>
                  <button
                    type="button"
                    onClick={() => {
                      setNotifOpen(false);
                      handleUserDropDown();
                    }}
                    aria-expanded={userDropdown}
                    aria-haspopup="menu"
                    className="inline-flex h-9 w-9 items-center justify-center overflow-hidden rounded-full ring-1 ring-[#E5E7EB] transition hover:ring-[#C7CBD6]"
                  >
                    {userData?.profile_image ? (
                      <img
                        src={userData.profile_image}
                        alt=""
                        className="h-full w-full object-cover"
                      />
                    ) : (
                      <span className="flex h-full w-full items-center justify-center bg-[#EEF0F5] text-sm font-bold text-[#374151]">
                        {userInitial}
                      </span>
                    )}
                  </button>

                  {userDropdown ? (
                    <div className="absolute right-0 top-[calc(100%+10px)] z-[10000] w-[260px] rounded-2xl border border-[#EEF0F5] bg-white p-4 shadow-[0_12px_40px_rgba(15,23,42,0.14)]">
                      <span className="absolute -top-1.5 right-5 h-3 w-3 rotate-45 border-l border-t border-[#EEF0F5] bg-white" />

                      <div className="relative mb-3">
                        <p className="text-base font-bold capitalize text-[#111827]">
                          {userNameFromRedux || "User"}
                        </p>
                        {displayEmail ? (
                          <p className="mt-0.5 truncate text-sm text-[#6B7280]">
                            {displayEmail}
                          </p>
                        ) : roleFromRedux ? (
                          <p className="mt-0.5 truncate text-sm text-[#6B7280]">
                            {roleFromRedux}
                          </p>
                        ) : null}
                      </div>

                      <div className="border-t border-[#F3F4F6] pt-2">
                        <button
                          type="button"
                          onClick={handleProfile}
                          className="flex w-full items-center gap-2.5 rounded-xl px-2 py-2.5 text-left text-sm font-medium text-[#374151] transition hover:bg-[#F3F4F6]"
                        >
                          <img src={UserIcon} alt="" className="h-4 w-4" />
                          My Account
                        </button>
                        <button
                          type="button"
                          onClick={handleSecurity}
                          className="flex w-full items-center gap-2.5 rounded-xl px-2 py-2.5 text-left text-sm font-medium text-[#374151] transition hover:bg-[#F3F4F6]"
                        >
                          <img src={chieldIcon} alt="" className="h-4 w-4" />
                          Security
                        </button>
                        <button
                          type="button"
                          onClick={logout}
                          className="flex w-full items-center gap-2.5 rounded-xl px-2 py-2.5 text-left text-sm font-medium text-[#DC2626] transition hover:bg-[#FEF2F2]"
                        >
                          <img src={logoutIcon} alt="" className="h-4 w-4" />
                          Logout
                        </button>
                      </div>
                    </div>
                  ) : null}
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {<IdealTime isDialogOpen={true} />}
      </Box>
    );
  };

  return getAppHeader();
};

export default AppHeader;
